import React, { useState } from 'react';
import applestore from '../assets/applestore.png';
import downloadapp from '../assets/downloadapp.jpg';
import Loader from '../common/Loader';

const DownloadScreen = () => {
  const [showLoader, setShowLoader] = useState(true);
  setTimeout(() => {
    setShowLoader(false);
  }, 1000);
  return (
    <div className='bg-[#37464D]'>
      {showLoader && (
        <div className='inline-block'>
          <Loader />
        </div>
      )}
      {!showLoader && (
        <div className='grid lg:grid-cols-2 container py-20 text-white '>
          <div className='text-left my-auto'>
            <h2 className='text-2xl uppercase font-semibold'>Get this app</h2>
            <p className='py-5'>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime
              voluptas excepturi exercitationem quia optio consequuntur odio
              ullam voluptatum fugiat facilis laudantium delectus, omnis
              expedita aperiam iure blanditiis, quidem, autem consectetur.
            </p>
            <p className='pb-8'>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime
              voluptas excepturi exercitationem quia optio consequuntur odio
              ullam voluptatum fugiat facilis laudantium delectus, omnis
              expedita aperiam iure blanditiis, quidem, autem consectetur.
            </p>

            <img
              src={applestore}
              alt=''
              style={{ maxWidth: '25%' }}
            />
          </div>
          <div className=''>
            <img
              src={downloadapp}
              alt='download-app'
              className='w-2/3 mx-auto'
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default DownloadScreen;
